(function () {
  function isCustomValue(value) {
    return /custom/i.test(value || '');
  }

  function productPicker(root) {
    var formComponent = root.closest('product-form-component');
    var productId = formComponent?.dataset.productId;
    if (!productId) return null;
    return document.querySelector('variant-picker[data-product-id="' + CSS.escape(productId) + '"]');
  }

  function selectedPickerValue(picker) {
    if (!picker) return '';
    var checked = picker.querySelector('fieldset:first-of-type input[type="radio"]:checked') || picker.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value || checked.dataset.optionValue || '';
    var select = picker.querySelector('select');
    return select?.options[select.selectedIndex]?.value || '';
  }

  function setPurchaseState(root, custom, complete) {
    var formComponent = root.closest('product-form-component');
    if (!formComponent) return;

    var blocked = custom && !complete;
    formComponent.classList.toggle('veera-custom-incomplete', blocked);
    var buttons = Array.from(formComponent.querySelectorAll('button[name="add"], .shopify-payment-button__button'));
    var section = formComponent.closest('.shopify-section');
    section?.querySelectorAll('sticky-add-to-cart').forEach(function (bar) {
      if (bar.dataset.productId !== formComponent.dataset.productId) return;
      buttons.push.apply(buttons, bar.querySelectorAll('button[ref="addToCartButton"]'));
    });
    buttons.forEach(function (button) {
      if (blocked) {
        if (!button.hasAttribute('data-veera-was-disabled')) {
          button.dataset.veeraWasDisabled = button.disabled ? 'true' : 'false';
        }
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      } else if (button.hasAttribute('data-veera-was-disabled')) {
        button.disabled = button.dataset.veeraWasDisabled === 'true';
        button.removeAttribute('aria-disabled');
        delete button.dataset.veeraWasDisabled;
      }
    });
  }

  function syncCustomFields(root) {
    var panel = root.querySelector('[data-veera-custom-measurements]');
    if (!panel) return;

    var custom = isCustomValue(selectedPickerValue(productPicker(root)));
    panel.hidden = !custom;

    var requiredFields = [];
    var lengthFields = [];
    panel.querySelectorAll('[data-veera-measurement]').forEach(function (field) {
      var isLength = ['short-kurti-length', 'normal-shirt-length', 'full-dress-length'].includes(field.dataset.veeraMeasurement);
      var required = custom && field.dataset.veeraMeasurement !== 'fit-notes' && !isLength;
      field.disabled = !custom;
      field.required = required;
      if (required) requiredFields.push(field);
      if (isLength) lengthFields.push(field);
    });

    lengthFields.forEach(function (field) { field.setCustomValidity(''); });
    var complete = requiredFields.every(function (field) {
      return field.value.trim() !== '' && field.checkValidity();
    }) && lengthFields.some(function (field) { return field.value.trim() !== '' && field.checkValidity(); });
    lengthFields.forEach(function (field) {
      field.setCustomValidity(custom && !complete && lengthFields.every(function (length) { return !length.value.trim(); }) ? 'Enter at least one garment length.' : '');
    });
    setPurchaseState(root, custom, complete);
  }

  function syncAll() {
    document.querySelectorAll('[data-veera-product-options]').forEach(syncCustomFields);
  }

  function initDialogs() {
    document.querySelectorAll('[data-veera-product-options]').forEach(function (root) {
      if (root.dataset.veeraInitialized === 'true') return;
      root.dataset.veeraInitialized = 'true';
      var dialog = root.querySelector('[data-veera-size-guide]');
      var open = root.querySelector('[data-veera-size-guide-open]');
      var close = root.querySelector('[data-veera-size-guide-close]');
      if (dialog && open) open.addEventListener('click', function () { dialog.showModal(); });
      if (dialog && close) close.addEventListener('click', function () { dialog.close(); });
      if (dialog) dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.closest('variant-picker') || event.target.matches('[data-veera-measurement]')) {
      window.setTimeout(syncAll, 0);
      window.setTimeout(syncAll, 250);
    }
  });

  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-veera-measurement]')) syncAll();
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('product-form-component form');
    if (!form) return;
    var root = form.querySelector('[data-veera-product-options]');
    if (!root || root.querySelector('[data-veera-custom-measurements]')?.hidden) return;
    if (!form.checkValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      form.reportValidity();
    }
  }, true);

  document.addEventListener('click', function (event) {
    var paymentButton = event.target.closest('.shopify-payment-button');
    var formComponent = paymentButton?.closest('product-form-component');
    if (formComponent?.classList.contains('veera-custom-incomplete')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      formComponent.querySelector('form')?.reportValidity();
    }
  }, true);

  new MutationObserver(function () {
    initDialogs();
    syncAll();
  }).observe(document.documentElement, { childList: true, subtree: true });

  initDialogs();
  syncAll();
})();
